import {
  // CalculatorIcon,
  CalendarIcon,
  // CheckCircleIcon,
  DatabaseIcon,
  SparklesIcon,
  // SupportIcon,
} from '@heroicons/react/outline'
import { c, FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import Container from 'components/landing/Container'
import Heading from 'components/landing/Heading'

const features = [
  {
    name: 'Качественные данные',
    description:
      'Наши данные отвечают строгим требованиям крупных компаний, с которыми мы работаем',
    icon: DatabaseIcon,
    class: 'bg-gray-500',
  },
  // {
  //   name: 'Единый тариф',
  //   description:
  //     'Даём полный доступ ко всем функциям. Когда ваш бизнес взлетит, вам не придётся переходить на тариф за миллион рублей в год',
  //   icon: CalculatorIcon,
  //   class: 'bg-blue-500',
  // },
  {
    name: 'Признанное качество аналитики',
    description:
      'Рейтинг AdIndex <a class="underline hover:no-underline" href="https://adindex.ru/ratings/tech/2023/314602/#314627" target="_blank">признал</a> Sellmonitor лучшим по качеству сервис аналитики на маркетплейсах',
    icon: SparklesIcon,
    class: 'bg-yellow-300',
  },
  {
    name: 'Работаем с 2019 года',
    description: 'А значит, собираем данные дольше всех и показываем самую полную картину',
    icon: CalendarIcon,
    class: 'bg-red-500',
  },
  // {
  //   name: 'Нет ограничений',
  //   description:
  //     'Сколько осталось генераций описания в этом месяце? Сколько угодно! А можно посмотреть данные за 2019 год? Да, и за любой период!',
  //   icon: CheckCircleIcon,
  //   class: 'bg-green-500',
  // },
  // {
  //   name: 'Поддержка в любой момент',
  //   description:
  //     'Мы всегда на связи — если у вас есть вопросы или что-то не получается, просто нажмите на кнопку внизу или напишите нам в Телеграме',
  //   icon: SupportIcon,
  //   class: 'bg-orange-500',
  // },
]

const Advantages: FC<{
  items?: typeof features
  title?: string
  description?: string
}> = ({ items, title, description }) => {
  const ctx = useUserContext()
  if (ctx.theme.hostType === 'sellscreen' && !items) return null

  return (
    <Container>
      <Heading
        tagline={title ?? 'Почему нас выбирают?'}
        description={
          description ??
          'Наша миссия — создать удобный сервис для комплексного управления магазинами на маркетплейсах. Мы развиваем инструменты аналитики, автоматизации и управления продажами, чтобы продавцы могли решать основные задачи в одном месте.'
        }
      />
      <ul
        role="list"
        className={c`grid max-w-2xl grid-cols-1 md:grid-cols-2 gap-10 px-2 mx-auto mt-16 text-base sm:mt-20 md:gap-y-10 lg:gap-y-18 gap-x-16 lg:max-w-none ${items?.length === 2} lg:grid-cols-2 | lg:grid-cols-3`}
      >
        {(items ?? features).map((feature) => (
          <li key={feature.name} className="relative">
            <feature.icon className="size-8" />
            <h3 className="mt-6 font-medium text-gray-900">{feature.name}</h3>
            <p
              className="mt-2 text-gray-700"
              dangerouslySetInnerHTML={{ __html: feature.description }}
            />
            <div
              className={c`absolute w-4 h-4 rounded-full top-2 lg:group-even:top-10 left-2 blur ${feature.class}`}
            />
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default Advantages
